// SLICE-REFERRAL — owner Referrals page data: entitlement/master-flag state,
// the live config (off the active loyalty program), and tenant-wide counts.

import { useQuery } from '@tanstack/react-query'
import type { ReferralConfig } from '@naya/shared'

import { ownerApi } from '../ownerApi.js'

export interface ReferralOverview {
  master_enabled: boolean
  entitled: boolean
  program_id: string | null
  total_stamps: number | null
  config: ReferralConfig | null
  counts: {
    codes_issued: number
    friends_joined: number
    rewards_paid: number
    pending: number
  }
}

export const referralOverviewKey = ['owner', 'referral', 'overview'] as const

// Scoped to a program for multi-program tenants (null = let the server pick the
// first active loyalty program). The program id is part of the query key so
// switching programs refetches; invalidating the base key still matches all.
export function useReferralOverview(programId?: string | null) {
  return useQuery<ReferralOverview>({
    queryKey: [...referralOverviewKey, programId ?? null],
    queryFn: () =>
      ownerApi.get<ReferralOverview>(
        `/owner/referral${programId ? `?program_id=${encodeURIComponent(programId)}` : ''}`,
      ),
    staleTime: 30_000,
  })
}
